import React, { Component } from 'react';
import { connect } from 'react-redux';
import { dAPI } from 'appSrc/api';
import LoadingReplace from 'appSrc/components/Shards/Loading/LoadingReplace';
import AllHomepageSettingsTable from './Table';
import { Link } from 'react-router-dom';
import style from './styles/style.module.css';

class AllHomepageSettingsView extends Component {
    constructor( props ) {
        super( props );
        this.state = {
            fetching: true,
            items: [],
        };

        this.itemQueryObject = {
            sort: 'id',
            page: 1,
            limit: 30,
        };
    }
    
    componentDidMount() {
        this.loadItems();
    }

    onColumnSort = ( value ) => {
        if( this.itemQueryObject.sort == value ) {
            value = `-${ value }`;
        }
        this.itemQueryObject.sort = value;
        this.itemQueryObject.page = 1;
        this.setState( {
            fetching: true,
            items: [],
        } );
        this.loadItems();
    }

    loadItems = () => {
        return this.props.getHomepageSettings( this.itemQueryObject )
        .then( ( items ) => {
            this.itemQueryObject.page++;
            this.setState( ( prevState ) => {
                prevState.fetching = false;
                prevState.items = prevState.items.concat( items );
                return prevState;
            } );
            return items;
        } );
    }

    itemUpdated = ( index, item ) => {
        this.setState( ( altState ) => {
            if( item !== null ) {
                altState.items[ index ] = item;
            } else {
                altState.items.splice( index, 1 );
            }
            altState.items = altState.items.slice( 0 );
            return altState;
        } );
    }

    openNewModal = () => {
        this.setState( { newModal: true } );
    }


    render() {
        const { fetching, items } = this.state;
        return (
            <section className={ style.page }>
                <div className={ style.head }>
                    <h2>Homepage</h2>
                    <div className={ style.controls }>
                        <br />
                        <br />
                    </div>
                    <div className={ style.tabs }>
                        <Link to='/admin/homepage/homepage_hero' className={ style.tabOption }>Items</Link>
                        <Link to='/admin/homepage/settings' className={ style.tabOption }
                        data-active={ true }>Settings</Link>
                    </div>
                </div>
                <div className={ style.body }>
                    <section className={ style.allItem }>
                        <div className={ style.filters }>
                        </div>
                        { fetching ?
                            <LoadingReplace />
                            :
                            <AllHomepageSettingsTable
                            items={ items }
                            loadMore={ this.loadItems }
                            currentSort={ this.itemQueryObject.sort }
                            onColumnSort={ this.onColumnSort }
                            onItemUpdated={ this.itemUpdated }
                            elementHeight={ 70 } />
                        }
                    </section>
                </div>
            </section>
        );
    }
}

const mapDispatchToProps = () => {
    return {
        getHomepageSettings: ( queryObject ) => {
            return dAPI.get( '/admin/settings/?context=homepage', queryObject );
        },
    };
};

export default connect( null, mapDispatchToProps )( AllHomepageSettingsView );
